import { Outlet } from "react-router-dom";

import { Chat } from "@app/features/chat/Chat";

import { useSchool } from "../lib/hooks";
import useScrollDirection from "../lib/hooks/useScrollDirection";
import { useUser } from "../lib/hooks/useUser";

import { LoadingOverlay } from "./LoadingOverlay";
import { UIAppState } from "./UIAppState/UIAppState";

export const LearnLayout: React.FC = () => {
  const user = useUser();
  const scrollDirection = useScrollDirection();
  const school = useSchool();

  if (user.user == null) return <LoadingOverlay />;

  return (
    <>
      <div data-scroll-direction={scrollDirection}>
        <Outlet />
      </div>
      {school.supportChatEnabled && <Chat />}
      <UIAppState />
    </>
  );
};
